import { Component, OnInit, Input, Inject, Output, EventEmitter } from '@angular/core';
import { Area } from '../../../resources/area/area.interface';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ConstantsFunctionality } from '../../../utilities/constants/constants.interface';
import { AuthService } from '../../../auth/auth.service';
import { AreaService } from '../../../resources/area/area.service';

/**
 * Inline edit for Area functionality.
 *
 * @todo Attach to AreaStore.
 */
@Component({
  selector: 'sg2-inline-edit-area-functionality',
  templateUrl: './area-functionality.component.html',
  styleUrls: ['./area-functionality.component.less']
})
export class InlineEditAreaFunctionalityComponent implements OnInit {

  /** Input area. */
  @Input() area: Area;

  /** Dispatch action. @deprecated. */
  @Output() action = new EventEmitter<Area>();

  /** Form. */
  public form: FormGroup;

  /** Functionalities. */
  public functionalities: ConstantsFunctionality[];

  /** Array with the ids of all the functionalities. */
  public functionalitiesIds: ConstantsFunctionality['_id'][];

  /**
   * Load the FormBuilder and bind the functionalities from the constants.
   *
   * @todo Angular2 ConstantsService.
   */
  constructor(
    @Inject('sgConstants') sgConstantsService: any,
    private areaService: AreaService,
    public authService: AuthService,
    private formBuilder: FormBuilder
  ) {
    this.functionalities = sgConstantsService.getList('FUNCTIONALITIES');
    this.functionalitiesIds = this.functionalities.map(functionality => functionality._id);
  }

  /**
   * Initialize new form, and hook into `form.functionality`.
   */
  ngOnInit() {
    this._newForm();
    this._trackFunctionality();
  }


  /**
   * Get the display name of an area functionality.
   *
   * @param id Functionality id.
   * @returns Functionality display name.
   */
  public getDisplayName(id: ConstantsFunctionality['_id']): ConstantsFunctionality['displayName'] {
    return this.functionalities.find(f => f._id === id).displayName;
  }

  /**
   * Initialize new form.
   */
  private _newForm(): void {
    this.form = this.formBuilder.group({
      functionality: this.area.functionality
    });
  }

  /**
   * Track the functionality.
   *
   * Dispatch the updated area after selecting a new `area.functionality`.
   *
   * @todo Update Area in the AreaStore.
   */
  private _trackFunctionality(): void {
    this.form.controls.functionality.valueChanges.subscribe(functionality => {
      // this.action.emit({ ...this.area, functionality: functionality });
      this.areaService.setFunctionality(this.area, functionality);
    });
  }
}
